var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgServersideIconSsaiChannelGrey = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "12 10.15 26.3 29.95",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HILFSLINIEN"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS_UMGEWANDELT"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#787878",
    d: "M36.996,32.791c-1.519-1.517-3.893-1.64-5.569-0.397l-1.797-1.798c0.804-0.994,1.288-2.258,1.288-3.633 c0-2.982-2.266-5.443-5.165-5.756V18.65c2.064-0.306,3.657-2.072,3.657-4.219c0-2.361-1.921-4.282-4.282-4.282 s-4.282,1.921-4.282,4.282c0,2.147,1.594,3.913,3.657,4.219v2.558c-2.899,0.313-5.165,2.774-5.165,5.756 c0,1.371,0.481,2.631,1.281,3.624l-1.794,1.794c-0.734-0.546-1.611-0.855-2.542-0.855c-1.145,0-2.219,0.445-3.027,1.254 c0,0.001-0.001,0.001-0.001,0.001C12.445,33.591,12,34.665,12,35.81c0,1.144,0.445,2.219,1.254,3.028 c0.835,0.834,1.932,1.251,3.028,1.251c1.096,0,2.192-0.417,3.028-1.252c1.518-1.518,1.64-3.893,0.397-5.568l1.796-1.796 c0.993,0.8,2.253,1.281,3.624,1.281c1.368,0,2.624-0.479,3.616-1.275l1.799,1.8c-1.243,1.675-1.121,4.051,0.396,5.57h0.001 c0.835,0.834,1.932,1.251,3.027,1.251c1.097,0,2.193-0.417,3.027-1.251c0.81-0.809,1.255-1.884,1.255-3.028 C38.25,34.676,37.805,33.601,36.996,32.791z M22.096,14.431c0-1.672,1.36-3.032,3.032-3.032s3.032,1.36,3.032,3.032 s-1.36,3.032-3.032,3.032S22.096,16.103,22.096,14.431z M18.427,37.953c-1.184,1.182-3.106,1.182-4.288,0 c-0.573-0.572-0.889-1.334-0.889-2.144c0-0.811,0.315-1.571,0.888-2.144l0.001-0.001c0.572-0.572,1.333-0.888,2.144-0.888 c0.81,0,1.571,0.315,2.144,0.889C19.608,34.848,19.608,36.771,18.427,37.953z M25.128,31.504c-2.503,0-4.54-2.037-4.54-4.54 c0-2.504,2.037-4.541,4.54-4.541s4.54,2.037,4.54,4.541C29.668,29.467,27.631,31.504,25.128,31.504z M36.111,37.963 c-1.182,1.184-3.104,1.182-4.288,0c-1.182-1.182-1.181-3.105,0-4.287c1.184-1.182,3.106-1.182,4.288,0 C36.685,34.248,37,35.01,37,35.819C37,36.63,36.685,37.391,36.111,37.963z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS_PFADE",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#787878",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    cx: 25.128,
    cy: 26.963,
    r: 5.165
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#787878",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    cx: 25.128,
    cy: 14.431,
    r: 3.657
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#787878",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    x1: 25.128,
    y1: 21.798,
    x2: 25.128,
    y2: 18.088
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#787878",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    cx: 33.968,
    cy: 35.819,
    r: 3.657
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#787878",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    x1: 28.785,
    y1: 30.636,
    x2: 31.382,
    y2: 33.234
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#787878",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    cx: 16.282,
    cy: 35.809,
    r: 3.657
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#787878",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    x1: 21.476,
    y1: 30.616,
    x2: 18.868,
    y2: 33.223
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "BESCHRIFTUNG"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgServersideIconSsaiChannelGrey, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/serverside-icon-ssai-channel-grey.b6b75ad1.svg";
export { ForwardRef as ReactComponent };